<script context="module">
  import { get_difference_in_days } from "./Utils.svelte";

  let mql_sources = [
    "Promotional Campaign: Leads",
    "Event",
    "Recommendation",
    "Webform - Request Quotation",
    "Social Media: Leads",
    "Incoming email",
    "Incoming Calls",
    "Webform - Call Back",
    "Webform - General Request",
    "Webform",
    "Webform - wants appointment",
    "Webform - WhatsApp",
    "Webform - contact reference farm",
    "Webinar participants ",

    //neu:
    "Promotional Campaign (Paid): Leads",
    "Social Media (Paid): Leads",
    "Press/Media",
    "Youtube - organic",
    "Promotional Campaigns (Organic): Leads",
    "Social Media (Organic): Leads",
  ];

  let mql_ids = [1, 2, 5, 3, 4, 7, 58, 8, 44, 46, 49, 70, 136, 227, 228, 224];

  let unq_sources = [
    "event", //(Ist Cold call in lost????)
    "Promotional Campaign: Prospects",
    "Cold call/cold visit/persönliche Recherche",
    "Webform - Download Brochure", //=> wird nicht gefunden "Webform - Download Broschüre"
    "Social Media: Prospects",
    "Webform - Newsletter Subscription", //=> "Webform - Newsletter Anmeldung"
    "Webform - Request Demo",
    "Press/Media", //=> "Presse/Berichterstattung"
    "Webform - Messenger",
    "Data Import",
  ];

  let unq_ids = [267, 272, 6, 10, 45, 47, 69, 132, 17];

  export function get_field_id_if_exists(element, field_name) {
    if (field_name in element) {
      if (Array.isArray(element[field_name])) {
        return element[field_name][0];
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  export function get_field_if_exists(element, field_name) {
    if (field_name in element) {
      if (Array.isArray(element[field_name])) {
        return element[field_name][1];
      } else {
        return element[field_name];
      }
    } else {
      return false;
    }
  }

  export function get_date_or_null(element, field_name) {
    if (!(field_name in element)) {
      return false;
    }

    if (element[field_name]) {
      if (new Date(element[field_name]) instanceof Date && isFinite(new Date(element[field_name]))) {
        return new Date(element[field_name]);
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  export function calc_astrid_table_conversion_rate(all_leads, res_partner_all, sale_order_all, from, to) {
    let lost_count_unq = 0;
    let lost_count_mql = 0;
    let lost_count_opp = 0;
    let lost_count_cus = 0;
    let lost_count_bol = 0;

    let count_unq = 0;
    let count_mql = 0;
    let count_opp = 0;
    let count_cus = 0;
    let count_bol = 0;

    let count_unq_open_or_created = 0;
    let count_mql_open_or_created = 0;
    let count_opp_open_or_created = 0;

    let a = mql_sources;

    var sources_list_with_id = [];

    var tmp_lost_list = [];
    var ids = ["267", "272", "6", "10", "45", "47", "69", "132", "17"];

    var unq_dict_per_source = {};

    unq_sources.forEach((s) => {
      unq_dict_per_source[s] = 0;
    });

    var unq_dict_per_source_lost = {};

    unq_sources.forEach((s) => {
      unq_dict_per_source_lost[s] = 0;
    });

    var mql_dict_per_source = {};

    mql_sources.forEach((s) => {
      mql_dict_per_source[s] = 0;
    });

    var mql_dict_per_source_lost = {};

    mql_sources.forEach((s) => {
      mql_dict_per_source_lost[s] = 0;
    });

    all_leads.forEach((element) => {
      // NICHT LOST:
      if (1 in element) {
        var obj = element[1];
        // //console.log("obj: ", obj)
        var create_date = new Date(obj["create_date"]);
        var source = get_field_if_exists(obj, "source_id");
        var stage = get_field_if_exists(obj, "stage_id");
        var conversion_date = get_date_or_null(obj, "date_conversion");
        var date_closed = get_date_or_null(obj, "date_closed");
        // var first_order_date = get_date_or_null(obj,'partner__first_order_date')

        if (!sources_list_with_id.includes(obj["source_id"][1].toString())) {
          if (ids.includes(obj["source_id"][0].toString())) {
            sources_list_with_id.push(obj["source_id"][1].toString());
          }
        }

        if (from <= create_date && to >= create_date) {
          if (unq_sources.includes(source)) {
            count_unq += 1;
            unq_dict_per_source[source] += 1;
          }
          if (mql_sources.includes(source)) {
            count_mql += 1;
            mql_dict_per_source[source] += 1;
          }
        } else {
          if ((!date_closed && create_date <= to) || (from <= date_closed && to >= date_closed)) {
            if (unq_sources.includes(source)) {
              count_unq_open_or_created += 1;
            }
            if (mql_sources.includes(source)) {
              count_mql_open_or_created += 1;
            }
          }
        }
        if (conversion_date && from <= conversion_date && to >= conversion_date) {
          count_opp += 1;
        } else {
          if (to >= conversion_date && !date_closed) {
            count_opp_open_or_created += 1;
          }
        }
      }
      // LOST:
      else {
        var obj = element;
        // console.log("lost obj: ", obj)
        var create_date = new Date(obj["x_date_creation"]);

        var source = get_field_if_exists(obj, "x_source");
        var stage = get_field_if_exists(obj, "x_stage");
        var conversion_date = get_date_or_null(obj, "x_date_conversion");
        var date_closed = get_date_or_null(obj, "x_date_closed");

        if (!mql_sources.includes(source)) {
          if (!tmp_lost_list.includes(source)) {
            tmp_lost_list.push(source);
          }
        }

        if (from <= create_date && to >= create_date) {
          if (unq_sources.includes(source)) {
            lost_count_unq += 1;
            unq_dict_per_source_lost[source] += 1;
          }
          if (mql_sources.includes(source)) {
            lost_count_mql += 1;
            mql_dict_per_source_lost[source] += 1;
          }
        } else {
          if ((!date_closed && create_date <= to) || (from <= date_closed && to >= date_closed)) {
            if (unq_sources.includes(source)) {
              count_unq_open_or_created += 1;
            }
            if (mql_sources.includes(source)) {
              count_mql_open_or_created += 1;
            }
          }
        }
        if (conversion_date && from <= conversion_date && to >= conversion_date) {
          lost_count_opp += 1;
        } else {
          if (to >= conversion_date && !date_closed) {
            count_opp_open_or_created += 1;
          }
        }
      }
    });

    // //console.log("unq_dict_per_source: ", unq_dict_per_source)
    // //console.log("unq_dict_per_source_lost: ", unq_dict_per_source_lost)
    // //console.log("sources_list_with_id: ", sources_list_with_id)
    // //console.log("tmp_lost_list: ", tmp_lost_list)

    // //console.log("mql_dict_per_source: ", mql_dict_per_source);
    // //console.log("mql_dict_per_source_lost: ", mql_dict_per_source_lost);

    res_partner_all.forEach((element) => {
      var obj = element[1];
      var first_order_date = get_date_or_null(obj, "first_order_date");
      if (first_order_date && first_order_date >= from && first_order_date <= to) {
        count_cus += 1;
      }
    });

    count_unq_open_or_created = count_unq_open_or_created + count_unq;
    count_mql_open_or_created = count_mql_open_or_created + count_mql;
    count_opp_open_or_created = count_opp_open_or_created + count_opp;

    // PARTNER:

    res_partner_all.forEach((element) => {
      var obj = element[1];
      var first_order_date = get_date_or_null(obj, "first_order_date");
      if (first_order_date && first_order_date >= from && first_order_date <= to) {
        count_cus += 1;
      }
    });

    return {
      count_unq: ((count_opp / count_unq_open_or_created) * 100).toFixed(1),
      count_mql: ((count_opp / count_mql_open_or_created) * 100).toFixed(1),
      count_opp: ((count_cus / count_opp_open_or_created) * 100).toFixed(1),
      count_cus: 0,
      count_bol: 0,
    };
  }

  export function calc_astrid_table_aging(all_leads, res_partner_all, sale_order_all, from, to) {
    let lost_count_unq = 0;
    let lost_count_mql = 0;
    let lost_count_opp = 0;
    let lost_count_cus = 0;
    let lost_count_bol = 0;

    let count_unq = 0;
    let count_mql = 0;
    let count_opp = 0;
    let count_cus = 0;
    let count_bol = 0;

    let list_of_unq_days_in_stage = [];
    let list_of_mql_days_in_stage = [];
    let list_of_opp_days_in_stage = [];

    all_leads.forEach((element) => {
      // NICHT LOST:
      if (1 in element) {
        var obj = element[1];
        // //console.log("obj: ", obj)
        var create_date = new Date(obj["create_date"]);
        var source = get_field_if_exists(obj, "source_id");
        var stage = get_field_if_exists(obj, "stage_id");
        var conversion_date = get_date_or_null(obj, "date_conversion");
        var date_closed = obj["date_closed"];
        // var first_order_date = get_date_or_null(obj,'partner__first_order_date')

        //UNQ:
        if (
          (from <= create_date && to >= create_date) ||
          (create_date <= to && !date_closed) ||
          (create_date <= to && date_closed <= to && date_closed >= from)
        ) {
          var age_start = create_date;
          var age_end = date_closed ? new Date(date_closed) : new Date();
          if (conversion_date) {
            age_end = conversion_date;
          }
          var days_in_unq = get_difference_in_days(age_start, age_end);
          list_of_unq_days_in_stage.push(days_in_unq);
        }

        //MQL:
        if (
          source &&
          mql_sources.includes(source) &&
          ((from <= create_date && to >= create_date) ||
            (create_date <= to && !date_closed) ||
            (create_date <= to && date_closed <= to && date_closed >= from))
        ) {
          var age_start = create_date;
          var age_end = date_closed ? new Date(date_closed) : new Date();
          if (conversion_date) {
            age_end = conversion_date;
          }
          var days_in_unq = get_difference_in_days(age_start, age_end);
          list_of_mql_days_in_stage.push(days_in_unq);
        }

        //OPP:
        if (conversion_date && ((conversion_date <= to && conversion_date >= from) || (conversion_date <= to && !date_closed))) {
          var age_start = conversion_date;
          var age_end = date_closed ? new Date(date_closed) : new Date();
          var days_in_unq = get_difference_in_days(age_start, age_end);
          list_of_opp_days_in_stage.push(days_in_unq);
        }
      }
      // LOST:
      else {
        var obj = element;
        // //console.log("obj: ", obj)
        var create_date = new Date(obj["x_date_creation"]);
        var source = get_field_if_exists(obj, "x_source");
        var stage = get_field_if_exists(obj, "x_stage");
        var conversion_date = get_date_or_null(obj, "x_date_conversion");
        var date_closed = obj["x_date_closed"];

        //UNQ:
        if (
          (from <= create_date && to >= create_date) ||
          (create_date <= to && !date_closed) ||
          (create_date <= to && date_closed <= to && date_closed >= from)
        ) {
          var age_start = create_date;
          var age_end = date_closed ? new Date(date_closed) : new Date();
          if (conversion_date) {
            age_end = conversion_date;
          }
          var days_in_unq = get_difference_in_days(age_start, age_end);
          list_of_unq_days_in_stage.push(days_in_unq);
        }

        //MQL:
        if (
          source &&
          mql_sources.includes(source) &&
          ((from <= create_date && to >= create_date) ||
            (create_date <= to && !date_closed) ||
            (create_date <= to && date_closed <= to && date_closed >= from))
        ) {
          var age_start = create_date;
          var age_end = date_closed ? new Date(date_closed) : new Date();
          if (conversion_date) {
            age_end = conversion_date;
          }
          var days_in_unq = get_difference_in_days(age_start, age_end);
          list_of_mql_days_in_stage.push(days_in_unq);
        }

        //OPP:
        if (conversion_date && ((conversion_date <= to && conversion_date >= from) || (conversion_date <= to && !date_closed))) {
          var age_start = conversion_date;
          var age_end = date_closed ? new Date(date_closed) : new Date();
          var days_in_unq = get_difference_in_days(age_start, age_end);
          list_of_opp_days_in_stage.push(days_in_unq);
        }
      }
    });

    list_of_unq_days_in_stage = list_of_unq_days_in_stage.sort(function (a, b) {
      return a - b;
    });
    let unq_age_median = list_of_unq_days_in_stage[Math.round(list_of_unq_days_in_stage.length / 2)];

    list_of_mql_days_in_stage = list_of_mql_days_in_stage.sort(function (a, b) {
      return a - b;
    });

    let mql_age_median = list_of_mql_days_in_stage[Math.round(list_of_mql_days_in_stage.length / 2)];

    list_of_opp_days_in_stage = list_of_opp_days_in_stage.sort(function (a, b) {
      return a - b;
    });
    let opp_age_median = list_of_opp_days_in_stage[Math.round(list_of_opp_days_in_stage.length / 2)];

    return {
      count_unq: (unq_age_median / 7).toFixed(1),
      count_mql: (mql_age_median / 7).toFixed(1),
      count_opp: (opp_age_median / 7).toFixed(1),
      count_cus: count_cus,
      count_bol: count_bol,
    };
  }

  export function calc_astrid_table_drop_out(all_leads, res_partner_all, sale_order_all, from, to) {
    let lost_count_cus = 0;
    let lost_count_bol = 0;

    let count_unq = 0;
    let count_mql = 0;
    let count_opp = 0;
    let count_cus = 0;
    let count_bol = 0;

    let count_all_lost = 0;

    let count_unq_open_or_created = 0;
    let count_mql_open_or_created = 0;
    let count_opp_open_or_created = 0;

    //UNQ:
    let lost_count_unq = 0; //X
    let open_unq_leads_created_within = 0; //X
    let open_unq_opportunities_created_within = 0; //X
    let won_unq_opportunities_last_stage_update = 0; //X

    //MQL:
    let lost_count_mql = 0; //X
    let open_mql_leads_created_within = 0; //X
    let open_mql_opportunities_created_within = 0;
    let won_mql_opportunity_last_stage_update = 0;

    //OPP:
    let lost_count_opp = 0; //XY
    let open_opportunities_created_within = 0; //XY
    let won_opportunities_last_stage_update = 0; //XY

    let won_mql_opportunity_last_stage_update_list = [];
    let lost_count_opp_list_of_leads = [];
    let lost_mql_list = [];

    let a = mql_sources;

    all_leads.forEach((element) => {
      // NICHT LOST:
      if (1 in element) {
        var obj = element[1];
        // //console.log("obj: ", obj)
        var create_date = new Date(obj["create_date"]);
        var source = get_field_if_exists(obj, "source_id");
        var source_id = get_field_id_if_exists(obj, "source_id");
        var stage = get_field_if_exists(obj, "stage_id");
        var stage_id = get_field_id_if_exists(obj, "stage_id");
        var conversion_date = get_date_or_null(obj, "date_conversion");
        var date_closed = get_date_or_null(obj, "date_closed");
        var last_stage_update = get_date_or_null(obj, "date_last_stage_update");
        var won_status = get_field_if_exists(obj, "won_status");
        var is_won = get_field_if_exists(obj, "is_won");
        var type = get_field_if_exists(obj, "type");
        var active = get_field_if_exists(obj, "active");

        //UNQ:
        if (type == "lead" && active == true && unq_sources.includes(source) && from <= create_date && to >= create_date) {
          open_unq_leads_created_within += 1;
        }
        if (
          type == "opportunity" &&
          active == true &&
          unq_sources.includes(source) &&
          from <= create_date &&
          to >= create_date &&
          stage_id != 5
        ) {
          open_unq_opportunities_created_within += 1;
        }
        if (is_won && unq_sources.includes(source) && from <= last_stage_update && to >= last_stage_update) {
          won_unq_opportunities_last_stage_update += 1;
        }

        //MQL:
        if (type == "lead" && active == true && mql_sources.includes(source) && from <= create_date && to >= create_date) {
          open_mql_leads_created_within += 1;
        }
        if (
          type == "opportunity" &&
          active == true &&
          mql_sources.includes(source) &&
          from <= create_date &&
          to >= create_date &&
          stage_id != 5
        ) {
          open_mql_opportunities_created_within += 1;
        }
        if (is_won == true && mql_sources.includes(source) && from <= last_stage_update && to >= last_stage_update) {
          won_mql_opportunity_last_stage_update += 1;

          won_mql_opportunity_last_stage_update_list.push(obj);
        }

        //OPP:
        if (type == "opportunity" && active == true && from <= create_date && to >= create_date && stage_id != 5) {
          open_opportunities_created_within += 1;
        }
        if (is_won == true && type == "opportunity" && active == true && from <= last_stage_update && to >= last_stage_update) {
          won_opportunities_last_stage_update += 1;
        }

        if (from <= create_date && to >= create_date) {
          if (unq_sources.includes(source)) {
            count_unq += 1;
          }
          if (mql_sources.includes(source)) {
            count_mql += 1;
          }
        } else {
          if ((!date_closed && create_date <= to) || (from <= date_closed && to >= date_closed)) {
            if (unq_sources.includes(source)) {
              count_unq_open_or_created += 1;
            }
            if (mql_sources.includes(source)) {
              count_mql_open_or_created += 1;
            }
          }
        }

        //COUNT OPPORTUNITES (UNTEN)

        if (conversion_date && from <= conversion_date && to >= conversion_date) {
          // console.log("OPP1 element: ", element)
          count_opp += 1;
        } else {
          if (conversion_date && from > conversion_date && (!date_closed || date_closed > from)) {
            // console.log("OPP2 element: ", element)
            if (!conversion_date) {
              // console.log("SOLLTE NICHT SEIN!!!")
              // console.log("conversion_date: ", conversion_date)
            }
            count_opp_open_or_created += 1;
          }
        }
      }
      // LOST:
      else {
        count_all_lost += 1;

        var obj = element;
        // console.log("lost obj: ", obj)
        var create_date = new Date(obj["x_date_creation"]);
        var source = get_field_if_exists(obj, "x_source");
        var stage = get_field_if_exists(obj, "x_stage");
        var conversion_date = get_date_or_null(obj, "x_date_conversion");
        var date_closed = get_date_or_null(obj, "x_date_closed");
        var x_lost_reason = get_field_if_exists(obj, "x_lost_reason");
        var type = get_field_if_exists(obj, "x_type");
        var last_stage_update = get_date_or_null(obj, "x_date_last_stage_update");

        var date_closed_field = obj["x_date_closed"];

        if (from <= date_closed && to >= date_closed) {
          if (unq_sources.includes(source)) {
            lost_count_unq += 1;
          }
          if (mql_sources.includes(source)) {
            lost_count_mql += 1;
            lost_mql_list.push(obj);
          }
        }

        if (type == "opportunity" && from <= date_closed && to >= date_closed) {
          lost_count_opp += 1;
          // console.log("date_closed_field: ", date_closed_field)
          lost_count_opp_list_of_leads.push(obj);
        }

        if (conversion_date && from <= conversion_date && to >= conversion_date) {
          count_opp_open_or_created += 1;
        }
      }
    });

    res_partner_all.forEach((element) => {
      var obj = element[1];
      var first_order_date = get_date_or_null(obj, "first_order_date");
      if (first_order_date && first_order_date >= from && first_order_date <= to) {
        count_cus += 1;
      }
    });

    count_unq_open_or_created = count_unq_open_or_created + count_unq;
    count_mql_open_or_created = count_mql_open_or_created + count_mql;
    count_opp_open_or_created = count_opp_open_or_created + count_opp;

    // console.log("LOST:")
    // console.log("lost_count_unq: ", lost_count_unq)
    // console.log("lost_count_mql: ", lost_count_mql)
    // console.log("lost_count_opp: ", lost_count_opp)

    // console.log("UNQ:")
    // console.log("open_unq_leads_created_within: ", open_unq_leads_created_within)
    // console.log("open_unq_opportunities_created_within: ", open_unq_opportunities_created_within)
    // console.log("won_unq_opportunities_last_stage_update: ", won_unq_opportunities_last_stage_update)
    // console.log("MQL:")
    // console.log("open_mql_leads_created_within: ", open_mql_leads_created_within)
    // console.log("open_mql_opportunities_created_within: ", open_mql_opportunities_created_within)
    // console.log("won_mql_opportunity_last_stage_update: ", won_mql_opportunity_last_stage_update)

    // console.log("OPPORTUNITES:")
    // console.log("open_opportunities_created_within: ", open_opportunities_created_within)
    // console.log("won_opportunities_last_stage_update: ", won_opportunities_last_stage_update)

    // console.log("LOST MQL LIST: ", lost_mql_list)

    var lost_rate_unq =
      lost_count_unq /
      (open_unq_leads_created_within + open_unq_opportunities_created_within + won_unq_opportunities_last_stage_update + lost_count_unq);

    var lost_rate_mql =
      lost_count_mql /
      (open_mql_leads_created_within + open_mql_opportunities_created_within + won_mql_opportunity_last_stage_update + lost_count_mql);

    var lost_rate_opp = lost_count_opp / (open_opportunities_created_within + won_opportunities_last_stage_update + lost_count_opp);

    return {
      count_unq: (lost_rate_unq * 100).toFixed(1),
      count_mql: (lost_rate_mql * 100).toFixed(1),
      count_opp: (lost_rate_opp * 100).toFixed(1),
      count_cus: 0,
      count_bol: 0,
    };
  }

  export function calc_cac(res_partner_all, from, to, acq_target) {
    // get target from year
    var Difference_In_Time = to.getTime() - from.getTime();
    let days = Difference_In_Time / (1000 * 3600 * 24);
    let acq_target_corrected = (acq_target * days) / 365;

    // target auf gewählte monate runterrechnen

    // anzahl gewonnener kunden im Zeitbereich berechnen
    let count_cus = 0;
    res_partner_all.forEach((element) => {
      var obj = element[1];
      var first_order_date = get_date_or_null(obj, "first_order_date");
      if (first_order_date && first_order_date >= from && first_order_date <= to) {
        count_cus += 1;
      }
    });

    return acq_target_corrected / count_cus;
  }

  export function calc_astrid_table(all_leads, res_partner_all, sale_order_all, from, to) {
    let count_unq = 0;
    let count_mql = 0;
    let count_opp = 0;
    let count_cus = 0;
    let count_bol = 0;

    let conversion_rate = 0;
    let count_unq_open_or_created = 0;

    // //console.log('from: ', from);
    // //console.log('to: ', to);

    // console.log('count sources dict:');
    let count_sources_dict = {};

    let a = mql_sources;

    // //console.log("all_leads: ", all_leads)

    all_leads.forEach((element) => {
      // NICHT LOST:
      if (1 in element) {
        var obj = element[1];
        var create_date = new Date(obj["create_date"]);
        var source = get_field_if_exists(obj, "source_id");
        var stage = get_field_if_exists(obj, "stage_id");
        var conversion_date = get_date_or_null(obj, "date_conversion");
        var date_closed = get_date_or_null(obj, "date_closed");
        // var first_order_date = get_date_or_null(obj,'partner__first_order_date')

        if (!(source in count_sources_dict)) {
          count_sources_dict[source] = 0;
        }

        if (from <= create_date && to >= create_date) {
          if (unq_sources.includes(source)) {
            count_unq += 1;
            count_sources_dict[source] += 1;
          }
          if (mql_sources.includes(source)) {
            count_mql += 1;
          }
        } else {
          if ((!date_closed && create_date <= to) || (from <= date_closed && to >= date_closed)) {
            if (unq_sources.includes(source)) {
              count_unq_open_or_created += 1;
              // count_sources_dict[source] += 1;
            }
          }
        }
        if (conversion_date && from <= conversion_date && to >= conversion_date) {
          count_opp += 1;
        }
      }
      // LOST:
      else {
        var obj = element;
        // //console.log("obj: ", obj)
        var create_date = new Date(obj["x_date_creation"]);
        var source = get_field_if_exists(obj, "x_source");
        var stage = get_field_if_exists(obj, "x_stage");
        var conversion_date = get_date_or_null(obj, "x_date_conversion");
        var date_closed = get_date_or_null(obj, "x_date_closed");

        if (!(source in count_sources_dict)) {
          count_sources_dict[source] = 0;
        }

        if (from <= create_date && to >= create_date) {
          if (unq_sources.includes(source)) {
            count_unq += 1;
            count_sources_dict[source] += 1;
          }
          if (mql_sources.includes(source)) {
            count_mql += 1;
          }
        } else {
          if ((!date_closed && create_date <= to) || (from <= date_closed && to >= date_closed)) {
            if (unq_sources.includes(source)) {
              count_unq_open_or_created += 1;
              // count_sources_dict[source] += 1;
            }
          }
        }
        if (conversion_date && from <= conversion_date && to >= conversion_date) {
          count_opp += 1;
        }
      }
    });

    // console.log('count_sources_dict: ', count_sources_dict);

    // PARTNER:

    res_partner_all.forEach((element) => {
      var obj = element[1];
      var first_order_date = get_date_or_null(obj, "first_order_date");
      if (first_order_date && first_order_date >= from && first_order_date <= to) {
        count_cus += 1;
      }
    });

    let liste_mai = [];

    // SALES:
    sale_order_all.forEach((sale) => {
      var obj = sale[1];
      var order_date = get_date_or_null(obj, "x_studio_order_date_mw");
      var product_amount = get_field_if_exists(obj, "product__amount");
      var state = get_field_if_exists(obj, "state");
      var salesman = get_field_if_exists(obj, "salesman_id");

      if (obj["order_type"]) {
        if (
          obj["order_type"] == "Warranty" ||
          obj["order_type"] == "Goodwill" ||
          obj["order_type"] == "Referral" ||
          obj["order_type"] == "goodwill" ||
          obj["order_type"] == "referral" ||
          obj["order_type"] == "Warranty / Goodwill"
        ) {
          return;
        }
      }
      if (obj["partner"]) {
        if (obj["partner"][1].toLowerCase().includes("smaxtec".toLowerCase())) {
          return;
        }
      }

      if (order_date && product_amount > 0 && order_date >= from && order_date <= to && (state == "done" || state == "sale")) {
        count_bol += product_amount;

        liste_mai.push(obj["id"]);
      } else {
      }
    });

    count_unq_open_or_created += count_unq;

    // console.log('count_cus: ', count_cus);
    // console.log('count_unq_open_or_created: ', count_unq_open_or_created);

    return {
      count_unq: count_unq,
      count_mql: count_mql,
      count_opp: count_opp,
      count_cus: count_cus,
      count_bol: count_bol,
      conversion_rate: (count_cus / count_unq_open_or_created) * 100,
    };
  }

  export function calc_astrid_table_is_open(all_leads, res_partner_all, sale_order_all, from, to) {
    let count_unq = 0;
    let count_mql = 0;
    let count_opp = 0;
    let count_cus = 0;
    let count_bol = 0;

    // //console.log('from: ', from);
    // //console.log('to: ', to);

    // //console.log("all_leads: ", all_leads)

    let a = mql_sources;

    all_leads.forEach((element) => {
      // NICHT LOST:
      if (1 in element) {
        var obj = element[1];
        // //console.log("obj: ", obj)
        var create_date = new Date(obj["create_date"]);
        var source = get_field_if_exists(obj, "source_id");
        var stage = get_field_if_exists(obj, "stage_id");
        var conversion_date = get_date_or_null(obj, "date_conversion");
        var date_closed = obj["date_closed"];
        // var first_order_date = get_date_or_null(obj,'partner__first_order_date')

        if (date_closed) {
          return;
        } else {
        }
        if (unq_sources.includes(source)) {
          count_unq += 1;
        }
        if (mql_sources.includes(source)) {
          count_mql += 1;
        }

        if (conversion_date) {
          count_opp += 1;
        } else {
          // //console.log("conversion_date: ", conversion_date)
        }
      }
    });

    // //console.log('count_unq OPEN: ', count_unq);
    // //console.log('count_mql OPEN: ', count_mql);
    // //console.log('count_opp OPEN: ', count_opp);
    // //console.log('count_cus: ', count_cus);
    // //console.log('count_bol: ', count_bol);

    return {
      count_unq: count_unq,
      count_mql: count_mql,
      count_opp: count_opp,
      count_cus: count_cus,
      count_bol: count_bol,
    };
  }
</script>
